// extracted by mini-css-extract-plugin
module.exports = {"banner_container":"wide-banner_banner_container__c2QW7"};